import { FilterDataType } from "./FilterDataType";
import { ColumnOptions, TableColumn } from "./TableColumn";

export class TableExpandColumn extends TableColumn {
    public colSkip?: number;
    public colSpan?: number;

    constructor(
        colSkip?: number,
        colSpan?: number,
        display?: (row: any) => any,
        options?: ColumnOptions,
        showTextBox?: boolean
    ) {
        super(
            "",                      // def
            "",                      // header
            FilterDataType.Object,   // dataType
            true,                    // showFilterDropdown
            false,                   // isDropdownOpen
            display,                 // display
            false,                   // sortable
            options,                 // options
            undefined,               // cellType (undefined, will default to TEXT)
            showTextBox,             // showTextBox
            false                    // showHyperLink
        );
        this.colSkip = colSkip ?? 0;
        this.colSpan = colSpan ?? 0;
    }
}
